<template>
    <transition name="red-packet-rain-fade">
        <div v-if="visible" class="red-packet-rain" @click="stop">
            <img
                v-for="item in packets"
                :key="item.id"
                class="red-packet-rain__item"
                :src="redPacketImg"
                :style="item.style"
                alt=""
            >
        </div>
    </transition>
</template>

<script>
import redPacketImg from '@/assets/redPacket/red-packet.png'

export default {
    name: 'RedPacketRain',
    data() {
        return {
            visible: false,
            redPacketImg,
            packets: [],
            closeTimer: null
        }
    },
    beforeDestroy() {
        this.clearCloseTimer()
    },
    methods: {
        play(count) {
            this.clearCloseTimer()
            // 红包数量：PC 默认 80 个，手机默认 32 个；调用 play(数量) 可以临时覆盖。
            const packetCount = count || (window.innerWidth <= 768 ? 50 : 88)
            this.packets = Array.from({ length: packetCount }, (_, index) => this.createPacket(index))
            this.visible = true
            // 自动关闭时间：红包雨播放 7.2 秒后自动移除遮罩和红包节点。
            this.closeTimer = window.setTimeout(() => {
                this.stop()
            }, 9200)
        },
        stop() {
            this.visible = false
            this.clearCloseTimer()
        },
        clearCloseTimer() {
            if (this.closeTimer) {
                window.clearTimeout(this.closeTimer)
                this.closeTimer = null
            }
        },
        createPacket(index) {
            // 手机模式判断：用于降低红包数量、尺寸和横向漂移，避免手机屏幕过密。
            const isMobile = window.innerWidth <= 768
            // 红包尺寸范围：手机 30-58px，PC 44-92px。
            const size = isMobile ? this.random(40, 68) : this.random(70, 120)
            // 下落时长范围：数值越大，下落越慢；手机略慢一点，视觉更柔和。
            const duration = isMobile ? this.random(3000, 8800) : this.random(2800, 8800)
            // 出现延迟范围：数值越大，红包出现得越分散，不会同一时间糊满屏。
            const delay = this.random(0, isMobile ? 8000 : 8000)
            // 横向漂移范围：红包下落时左右偏移距离，手机收窄以减少遮挡。
            const drift = isMobile ? this.random(-240, 0) : this.random(-580, 0)
            // 旋转角度：每个红包随机起始角度和结束角度，让下落更自然。都改成0不旋转
            const rotateStart = this.random(-35, 35)
            const rotateEnd = rotateStart + this.random(180, 540) * (Math.random() > 0.5 ? 1 : -1)

            return {
                id: `${Date.now()}-${index}`,
                style: {
                    left: `${this.random(-5, 100)}vw`,
                    width: `${size}px`,
                    height: `${size}px`,
                    animationDuration: `${duration}ms`,
                    animationDelay: `${delay}ms`,
                    '--rain-drift': `${drift}px`,
                    '--rain-rotate-start': `${rotateStart}deg`,
                    '--rain-rotate-end': `${rotateEnd}deg`
                }
            }
        },
        random(min, max) {
            return Math.round(Math.random() * (max - min) + min)
        }
    }
}
</script>

<style lang="scss" scoped>
.red-packet-rain {
    position: fixed;
    inset: 0;
    z-index: 9999;
    overflow: hidden;
    pointer-events: auto;
    background: rgba(0, 0, 0, 0.08);
}

.red-packet-rain__item {
    position: absolute;
    top: -120px;
    object-fit: contain;
    pointer-events: none;
    user-select: none;
    filter: drop-shadow(0 8px 10px rgba(0, 0, 0, 0.28));
    animation-name: redPacketFall;
    animation-timing-function: linear;
    animation-fill-mode: both;
}

.red-packet-rain-fade-enter-active,
.red-packet-rain-fade-leave-active {
    transition: opacity .25s ease;
}

.red-packet-rain-fade-enter,
.red-packet-rain-fade-leave-to {
    opacity: 0;
}

@keyframes redPacketFall {
    0% {
        opacity: 0;
        transform: translate3d(0, -120px, 0) rotate(var(--rain-rotate-start)) scale(.9);
    }

    8% {
        opacity: 1;
    }

    100% {
        opacity: .95;
        transform: translate3d(var(--rain-drift), calc(100vh + 160px), 0) rotate(var(--rain-rotate-end)) scale(1.05);
    }
}
</style>
